import { createPeopleChatApi } from '@rocket-technology-ltd/people-chat/client';
import type { ChatApi } from '@rocket-technology-ltd/people-chat/client';
import APICallService from '../../../../api/apiCallService';
import { PEOPLE_CHAT } from '../../../../api/apiEndPoints';

export type {
  ChatApi,
  ChatConversation,
  ChatDirectory,
  ChatEvent,
  ChatMessage,
  ChatPage,
  ChatPreferences,
  ChatPresenceEvent,
  ChatUser,
} from '@rocket-technology-ltd/people-chat/client';
export { defaultChatPreferences } from '@rocket-technology-ltd/people-chat/client';

const request: Parameters<typeof createPeopleChatApi>[0] = async (
  endpoint,
  scopeId,
  params,
  responseType
) =>
  await new APICallService(
    endpoint,
    params,
    undefined,
    responseType,
    'en',
    false,
    undefined,
    scopeId
  ).callAPI();

export const chatApi: ChatApi = createPeopleChatApi(request, PEOPLE_CHAT);
